import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { formatDateTime } from 'utils/utils';

// Displays when and by whom an alert was acknowledged
const AcknowledgementInfo = ({ acknowledgedAt, acknowledgedByName }) => {
	if (!acknowledgedAt || !acknowledgedByName) {
		return null;
	}

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '3px',
				mt: '2px',
			}}
		>
			<CheckIcon
				sx={{
					fontSize: '14px',
					color: 'signal.green',
					flexShrink: 0,
				}}
			/>

			<Typography
				sx={{
					fontSize: '11px',
					fontWeight: 600,
					color: 'status.green.text',
				}}
			>
				{`Acknowledged ${formatDateTime(acknowledgedAt)} - ${acknowledgedByName}`}
			</Typography>
		</Box>
	);
};

AcknowledgementInfo.propTypes = {
	acknowledgedAt: PropTypes.string,
	acknowledgedByName: PropTypes.string,
};

export default AcknowledgementInfo;
